import { Box, Button, Stack } from '@mui/material';
import DeleteOutlined from '@ant-design/icons/DeleteOutlined';

const ImageUpload = ({
  imagePreview,
  onImageChange,
  onImageRemove,
  id = 'image-upload',
  label = 'Upload Image',
  showRemoveButton = true,
}) => {
  const handleRemove = () => {
    // Reset the file input
    const fileInput = document.getElementById(id);
    if (fileInput) {
      fileInput.value = '';
    }
    if (onImageRemove) {
      onImageRemove();
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <input
        accept="image/*"
        style={{ display: 'none' }}
        id={id}
        type="file"
        onChange={onImageChange}
      />
      <Stack direction="row" spacing={1} sx={{ mb: imagePreview ? 2 : 0 }}>
        <label htmlFor={id} style={{ flex: 1 }}>
          <Button variant="outlined" component="span" fullWidth>
            {imagePreview ? 'Change Image' : label}
          </Button>
        </label>
        {imagePreview && showRemoveButton && (
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
            onClick={handleRemove}
            sx={{ minWidth: 120 }}
          >
            Remove
          </Button>
        )}
      </Stack>
      {imagePreview && (
        <Box
          component="img"
          src={imagePreview}
          alt="Preview"
          sx={{ mt: 2, maxWidth: '100%', maxHeight: 200, borderRadius: 1 }}
        />
      )}
    </Box>
  );
};

export default ImageUpload;

